import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, isValidElement } from "react";
import * as Styled from "./ActionList.styled";
import { ActionListItem } from "./ActionListItem";
export const ActionList = forwardRef((props, ref) => {
    const { actions, actionsHaveIcons, layout = "start", shouldAutoFocusMenu, ...rest } = props;
    const hasIcons = actionsHaveIcons || actions.some((action) => action && action.icon);
    const actionsLength = actions.length;
    return (_jsx(Styled.ActionList, { ref: ref, role: actionsLength ? "menu" : undefined, "data-testid": "ActionList", keyboardDirection: "vertical", shouldAutoFocus: shouldAutoFocusMenu, hasIcons: hasIcons, layout: layout, ...rest, children: actions.map((action, index) => {
            if (isValidElement(action)) {
                return action;
            }
            const { label, icon, actions, disabled, ...restOfAction } = action;
            return (_jsx(ActionListItem, { label: label, icon: icon, actions: actions, isLastItem: actionsLength - 1 === index, disabled: disabled, layout: layout, ...restOfAction }, typeof label === "string" ? `${label}_${index}` : index));
        }) }));
});
ActionList.displayName = "ActionList";
ActionList.defaultProps = {
    shouldAutoFocusMenu: true
};
